<!--
 * @Descripttion:
 * @Author: liang
 * @Date: 2021-04-20 11:15:47
 * @LastEditors: liang
 * @LastEditTime: 2021-09-10 18:15:19
-->
<template>
  <div class="modal" v-if="show">
    <div class="loginregister">
      <div class="close" @click="close">×</div>
      <div class="title">
        <span>修改密码</span>
      </div>
      <el-form ref="form" :model="form" :rules="rules" @keyup.enter.native="reset">
        <div class="form">
            <el-form-item  prop="username">
              <div class="formline">
                <el-input v-model="form.username" readonly placeholder="请您输入账号"></el-input>
                <i class="el-icon-user"></i>
              </div>
            </el-form-item>
            <el-form-item  prop="password">
              <div class="formline">
                <el-input type="password" v-model="form.password" placeholder="请您输入原密码"></el-input>
                <i class="el-icon-unlock"></i>
              </div>
            </el-form-item>
            <el-form-item  prop="newPassword">
              <div class="formline">
                <el-input v-model="form.newPassword" placeholder="请您输入新密码"></el-input>
                <i class="el-icon-key"></i>
              </div>
            </el-form-item>
            <el-form-item  prop="qnewPassword">
              <div class="formline">
                <el-input v-model="form.qnewPassword" placeholder="请您确认新密码"></el-input>
                <i class="el-icon-key"></i>
              </div>
            </el-form-item>
            <el-button type="success" @click="reset" :loading='btnload'>修改密码</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loginregister',
  data () {
    return {
      dialogVisible: false,
      show: false,
      btnload: false,
      form: {
        username: '',
        password: '',
        newPassword: ''
      }

    }
  },
  computed: {
    rules () {
      var validateComfirmPassword = (rule, value, callback) => {
        if (this.form.newPassword !== value) {
          return callback(new Error('两次密码输入不一致'))
        }
        callback()
      }
      return {
        username: [
          {
            required: true,
            message: '请必填',
            trigger: 'blur'
          }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 4, max: 16, message: '密码长度在 4 到 16 个字符', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 4, max: 16, message: '密码长度在 4 到 16 个字符', trigger: 'blur' }
        ],
        qnewPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { min: 4, max: 16, message: '密码长度在 4 到 16 个字符', trigger: 'blur' },
          { validator: validateComfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (val) {
      this.form.username = JSON.parse(localStorage.getItem('user')).username
      this.form.password = ''
      this.show = true
    },
    close () {
      // 关闭登录注册弹框
      this.show = false
    },
    reset () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.btnload = true
          this.$put('/sys/user/password', this.form).then(res => {
            this.btnload = false
            if (res.code === 0) {
              this.$message.success('修改成功！')
              this.show = false
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.modal {
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}
.loginregister {
  width: 380px;
  background: #fff;
  position: fixed;
  left: 50%;
  margin-left: -190px;
  top: 200px;
  border-radius: 3px;
  border: 1px solid #eee;
}
.close {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 36px;
  line-height: 48px;
  padding-right: 10px;
  z-index: 2;
  cursor: pointer;
}
.close:hover {
  color: #409eff;
}
.title {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
}
.form {
  padding: 0 30px;padding-top: 22px;
}
.formline {
  position: relative;
  /* margin-top: 25px; */
}
.formline > i {
  position: absolute;
  z-index: 12;
  color: #999;
  font-size: 20px;
  left: 10px;
  top: 10px;
}
.formline /deep/.el-input__inner {
  padding-left: 36px;
}
.form > button {
  width: 100%;
  margin: 0 0 30px 0;
}
.otheropt {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
.otheropt span {
  cursor: pointer;
}
.otheropt span:hover {
  color: #409eff;
}
.yzmimg {
  position: absolute;
  z-index: 23;
  right: 0;
  top: 0;
  height: 40px;
  max-width: 120px;
}
div/deep/.el-dialog__body {
  padding: 10px 20px;
  max-height: 450px;
  overflow-y: auto;
}
div/deep/ input::-webkit-input-placeholder {
    color: #666;
  }
  div/deep/ input::-moz-input-placeholder {
    color: #666;
  }
  div/deep/ input::-ms-input-placeholder {
    color: #666;
  }
</style>
